import { PartnerRemoveNoMembershipSummary } from '@features/ForestOwner/EditShareOwnership/Partner/PartnerRemoveNoMembershipSummary'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate/useTranslations'

export const Route = createFileRoute(
  '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove/summary/',
)({
  component: () => <PartnerRemoveNoMembershipSummary />,
  staticData: {
    breadcrumb: t('forestowner-editshareownership-partner.removeBreadcrumb'),
  },
})
